import { Button, ButtonSize, Icon, Typography, useMediaQuery } from "@kyan/ui";

interface PnlCardGeneratorActionsProps {
  download: () => void;
  shareOnX: () => void;
  copyImage: () => void;
}

export const PnLCardGeneratorActions: React.FC<
  PnlCardGeneratorActionsProps
> = ({ download, shareOnX, copyImage }) => {
  const { isSm } = useMediaQuery();

  const typographySize = isSm ? 15 : 12;
  const buttonSize: ButtonSize = isSm ? "lg" : "md";

  return (
    <div className="flex w-full flex-col gap-2">
      <div className="flex w-full items-center gap-2">
        <Button
          size={buttonSize}
          variant="secondary"
          className="flex w-full items-center gap-2"
          onClick={() => {
            download();
          }}
        >
          <Typography size={typographySize}>Download</Typography>
          <Icon name="download" />
        </Button>
        <Button
          size={buttonSize}
          variant="secondary"
          className="flex w-full items-center gap-2"
          onClick={() => {
            copyImage();
          }}
        >
          <Typography size={typographySize}>Copy</Typography>
          <Icon name="copy" />
        </Button>
        <Button
          size={buttonSize}
          variant="primary"
          className="flex w-full items-center gap-2 shadow-none"
          onClick={() => {
            shareOnX();
          }}
        >
          <Typography size={typographySize}>Share on</Typography>
          <Icon name="x" />
        </Button>
      </div>
      <div className="bg-buttonHover flex flex-col gap-2 rounded-sm p-4 dark:text-white">
        <Typography size={16} weight="semibold">
          Instructions to share on X:
        </Typography>
        <ul className="list-inside list-disc space-y-2">
          <li>
            <Typography>Copy PnL image to clipboard.</Typography>
          </li>
          <li>
            <Typography>Click to share and x.com will open.</Typography>
          </li>
          <li>
            <Typography>
              Paste the image into tweet (ctrl + v or cmd + v on mac).
            </Typography>
          </li>
        </ul>
      </div>
    </div>
  );
};
